import inView from './inView'
import splitScroll from '../../modules/Split-Scroll/Split-Scroll'

const scroll = {
  enable() {
    const _ = {
      allNav: document.querySelectorAll('.c-navigation__item'),
      navList: document.querySelector('.c-navigation__list'),
    }

    let page = 'Page'
    let areas = ['spirits', 'recipes', 'story', 'stockists']

    if (document.querySelector('.template-index')) {
      page = 'Home'
    } else if (document.querySelector('.template-trade')) {
      page = 'Trade'
    }

    if (page === 'Trade') {
      if (localStorage.getItem('company') === null) window.location = '/'
      areas = ['spirits', 'resources', 'learn']
    }

    if (page === 'Home' || page === 'Trade') {
      window.onscroll = () => {
        if (document.querySelector('.c-navigation__item.is-active')) {
          _.navList.classList.add('is-inactive')
        } else {
          _.navList.classList.remove('is-inactive')
        }

        for (const el of areas) {
          const elm = document.querySelector(`#${el}`)
          const target = document.querySelector(`a[href="#${el}"]`)

          if (target && inView(`#${el}`)) {
            if (elm.getBoundingClientRect().top < 120) {
              for (const nav of _.allNav) nav.classList.remove('is-active')
              target.parentNode.classList.add('is-active')
            } else {
              elm.classList.remove('is-active')
            }
          } else if (target) {
            target.parentNode.classList.remove('is-active')
          }
        }
      }
    }

    if (page === 'Home') {
      splitScroll.enable()
    }
  },
}

export default {
  enable: scroll.enable,
}
